export function typewriter(node) {
  let requestId;
  let index = 0;
  let letters = Array.from(node.children).filter((d) => d.nodeName !== "BR");

  let showLetter = () => {
    letters[index].classList.add("active-letter");
    letters[index].classList.remove("invisible");

    if (index > 0) {
      letters[index - 1].classList.remove("active-letter");
    }

    index += 1;

    if (index < letters.length) {
      requestId = window.requestAnimationFrame(showLetter);
    }
  };

  window.requestAnimationFrame(showLetter);

  return {
    destroy() {
      cancelAnimationFrame(requestId);
    },
  };
}
